import { render } from "./hotelCard.vue?vue&type=template&id=ecce6e50&scoped=true"
import script from "./hotelCard.vue?vue&type=script&lang=js"
export * from "./hotelCard.vue?vue&type=script&lang=js"

import "./hotelCard.vue?vue&type=style&index=0&id=ecce6e50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecce6e50"]])

export default __exports__